import request from '@/axios'
import post from '@/axios/upload'

// 获取权限列表1
export function getAuthList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/auth/getAuthList',
    method: 'post',
    data
  })
}

// 获取小区（无登陆）
export function getAllVillageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getAllVillageList',
    method: 'post',
    data
  })
}

// 获取上传图片Token
export function getUploadToken(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/getUploadToken',
    method: 'post',
    data
  })
}
// 根据value获取key
export function getKey(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/key_value/getKey',
    method: 'post',
    data
  })
}
// 获取权限列表
export function upLoadImage(file, data) {
  const param = new FormData()
  param.append('file', file)
  if (data) {
    Object.keys(data).forEach(element => {
      param.append(element, data[element])
    })
  }
  return post({
    url: '//upload.qiniup.com',
    method: 'post',
    data: param,
    config: {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  })
}

// 11-获取门店POS支付状态信息
export function getStorePayStatusInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/getStorePayStatusInfo',
    method: 'post',
    data
  })
}

// 22-获取门店列表
export function getStoreList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getStoreList',
    method: 'post',
    data
  })
}
